export const accent = '#B8141B';
